import React from "react";
import {Input} from "antd";
import {SplitInputWrapperProps, InputWrapper} from "../../functions";
import {InputBoxProps} from "./interface";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const TextInputBox: React.FC<InputBoxProps> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.text());
    }

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
        >
            <Input placeholder={formProps?.label} {...inputProps} />
        </InputWrapper>
    );
};

export default TextInputBox;
